import svc from "@/services/entSrch.svc";

export default {
  state: {
    enterpriseObjects: []
  },
  getters: {
    getEnterpriseObjects: state => state.enterpriseObjects,
    getActiveEnterpriseObject: state =>
      state.enterpriseObjects.find(p => p.isActive)
  },
  mutations: {
    setEnterpriseObjects(state, payload) {
      state.enterpriseObjects = payload;
    },
    setActiveObject(state, payload) {
      let idx = state.enterpriseObjects.findIndex(
        p => p.viewName === payload.viewName
      );
      if (idx > -1) {
        state.enterpriseObjects = state.enterpriseObjects.map(p =>
          Object.assign(p, { isActive: p.viewName === payload.viewName })
        );
      }
    }
  },
  actions: {
    getEnterpriseObjectsAsync({ commit }) {
      return svc.getEnterpriseObjects().then(res => {
        commit("setEnterpriseObjects", res);
      });
    }
  }
};
